export  class JustpayPointModel {
    constructor () {
        this.date=new Date()
        this.configurationUpdated = new Date()
        this.model=''
        this.submodel=''
        this.batteryPercent=''
        this.lastSale=new Date()
        this.terminalId=''
        this.libraryVersion=''
    }
}
